export const PATH_SNAPSHOT_DEBOUNCE_MS = 500;
